/* eslint-disable eqeqeq */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Flex,
  Checkbox,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";

import {
  useLookupPermissions,
  useLookupResources,
} from "../../services/lookups-queries";
import FormInput from "../../components/forms/form-Input";
import {
  useCreateRole,
  useEditRole,
  useGetRole,
  useGetUsersList,
} from "../../services/auth-api";
import { formDefaultValues } from "./constants";
import ReactHookFormDropdown from "components/forms/react-hook-dropdown";
import { Textarea } from "@repo/ui";

export default function AddRole() {
  const navigate = useNavigate();
  const params = useParams();
  const {
    mutate: getRole,
    isSuccess: isRoleAvailable,
    data: roleDetails,
    isPending: gettingRole,
  } = useGetRole();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
  } = useCreateRole();
  const {
    mutate: editRoleRequest,
    isSuccess: isEditingSuccessful,
    isPending: requestingRoleEditing,
  } = useEditRole();
  const { data: employees, mutate: getUsersList } = useGetUsersList();
  const { data: resourcesRes, isPending: gettingResources } =
    useLookupResources();
  const { data: rolePermissionRes, isPending: gettingRolePermission } =
    useLookupPermissions();

  const {
    handleSubmit,
    control,
    getValues,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: { ...formDefaultValues },
  });

  const formValidationRules = {
    role: { required: "Please Enter Role Name" },
    description: { required: "Please Enter Description" },
  };
  const generalFieldProps = { errors, control };

  const { fields: permissionsFields } = useFieldArray({
    control: generalFieldProps.control,
    name: "permissions",
  });

  const ensureConsistentType = (value) => {
    if (value === null || value === undefined) return value;
    const num = Number(value);
    return isNaN(num) ? String(value) : num;
  };

  useEffect(() => {
    getUsersList();
  }, []);
  useEffect(() => {
    if (params.roleName) {
      const name = params.roleName.split("_").join(" ");
      getRole(name);
    }
  }, [params.roleName, getRole]);

  useEffect(() => {
    if (
      isRoleAvailable &&
      resourcesRes &&
      rolePermissionRes &&
      roleDetails?.data
    ) {
      reset({
        roleName: roleDetails.data.name,
        description: roleDetails.data.description,
        permissions: roleDetails.data.permissions.map((elm) => ({
          resource: ensureConsistentType(elm.resourceKey),
          permission: ensureConsistentType(elm.permissionKey),
        })),
      });
    }
  }, [isRoleAvailable, rolePermissionRes, resourcesRes, roleDetails, reset]);

  useEffect(() => {
    if (isRequestCreated || isEditingSuccessful) {
      reset(formDefaultValues);
      navigate(Paths.roles);
    }
  }, [isEditingSuccessful, isRequestCreated, navigate, reset]);

  const onSubmit = (data) => {
    const _payload = {
      name: data.roleName,
      description: data.description,
      requestedBy: data.requestedBy,
      comments: data.comments,
      permissions: data.permissions.map((elm) => ({
        resource: Number(elm.resource),
        permission: Number(elm.permission),
      })),
    };
    if (params.roleName) {
      editRoleRequest(_payload);
    } else {
      createRequest(_payload);
    }
  };

  const addAllPermissions = (role) => {
    if (!rolePermissionRes?.data) return;

    const allPossiblePermissionTypeValues = rolePermissionRes.data.map(
      (permDef) => ensureConsistentType(permDef.value),
    );
    const targetResourceValue = ensureConsistentType(role.value);

    const currentFormPermissionsData = (getValues().permissions || []).map(
      (p) => ({
        resource: ensureConsistentType(p.resource),
        permission: ensureConsistentType(p.permission),
      }),
    );

    const permissionsForOtherResources = currentFormPermissionsData.filter(
      (p) => p.resource !== targetResourceValue,
    );
    const currentPermissionsForTargetResource =
      currentFormPermissionsData.filter(
        (p) => p.resource === targetResourceValue,
      );

    const areAllCurrentlySelectedForTarget =
      currentPermissionsForTargetResource.length ===
        allPossiblePermissionTypeValues.length &&
      allPossiblePermissionTypeValues.every((permTypeValue) =>
        currentPermissionsForTargetResource.some(
          (p) => p.permission === permTypeValue,
        ),
      );

    let newPermissionsSetForTargetResource = [];
    if (areAllCurrentlySelectedForTarget) {
      newPermissionsSetForTargetResource = [];
    } else {
      newPermissionsSetForTargetResource = allPossiblePermissionTypeValues.map(
        (permTypeValue) => ({
          resource: targetResourceValue,
          permission: permTypeValue,
        }),
      );
    }

    const finalUpdatedPermissions = [
      ...permissionsForOtherResources,
      ...newPermissionsSetForTargetResource,
    ];

    setValue("permissions", finalUpdatedPermissions, {
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const updatePermission = (clickedRoleResource, clickedPermDef) => {
    const targetResourceVal = ensureConsistentType(clickedRoleResource.value);
    const targetPermissionVal = ensureConsistentType(clickedPermDef.value);

    const currentPermissionsData = (getValues().permissions || []).map((p) => ({
      resource: ensureConsistentType(p.resource),
      permission: ensureConsistentType(p.permission),
    }));

    const existingPermissionIndex = currentPermissionsData.findIndex(
      (p) =>
        p.resource === targetResourceVal &&
        p.permission === targetPermissionVal,
    );

    let newPermissionsData;

    if (existingPermissionIndex !== -1) {
      newPermissionsData = currentPermissionsData.filter(
        (_, index) => index !== existingPermissionIndex,
      );
    } else {
      const newPermissionEntry = {
        resource: targetResourceVal,
        permission: targetPermissionVal,
      };
      newPermissionsData = [...currentPermissionsData, newPermissionEntry];
    }

    setValue("permissions", newPermissionsData, {
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <>
      {creatingRequest ||
      gettingRolePermission ||
      gettingResources ||
      requestingRoleEditing ||
      gettingRole ? (
        <Loader />
      ) : null}
      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Roles", link: Paths.roles },
            {
              text: params.roleName ? "Edit Role" : "Create Role",
              isCurrentPage: true,
            },
          ]}
        />{" "}
        <Card flexDirection="column" w="100%">
          <CardBody>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="add-location-form"
            >
              <FormInput
                {...generalFieldProps}
                isRequired
                label="Role Name"
                name="roleName"
                rules={formValidationRules.role}
                readOnly={params.roleName}
              />
              <FormInput
                {...generalFieldProps}
                isRequired
                label="Description"
                name="description"
                rules={formValidationRules.description}
              />
              <FormInput
                {...generalFieldProps}
                label="Requested By"
                name="requestedBy"
              />
              <div className="full-width-field">
                {" "}
                <FormControl>
                  <FormLabel>Comments</FormLabel>
                  <Controller
                    control={control}
                    name="comments"
                    render={({ field }) => (
                      <Textarea
                        value={field.value}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                </FormControl>
              </div>
              <table className="roles-perm-table">
                <thead>
                  <tr>
                    <th style={{ textAlign: "start" }}>Module</th>
                    <th>Select All</th>
                    {rolePermissionRes?.data.map((permDef, index) => (
                      <th
                        width="100px"
                        key={`header-${ensureConsistentType(permDef.value)}-${index}`}
                      >
                        {permDef.text}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {resourcesRes?.data.map((roleResource, rowIndex) => (
                    <tr
                      key={`resource-${ensureConsistentType(roleResource.value)}-${rowIndex}`}
                    >
                      <td style={{ fontWeight: "bold" }}>
                        {roleResource.text}
                      </td>
                      <td>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title={`Select/Deselect all for ${roleResource.text}`}
                        >
                          <Checkbox
                            isChecked={(() => {
                              if (
                                !rolePermissionRes?.data ||
                                rolePermissionRes.data.length === 0
                              )
                                return false;
                              const currentResourceVal = ensureConsistentType(
                                roleResource.value,
                              );
                              const permsForThisResourceInFields =
                                permissionsFields.filter(
                                  (field) =>
                                    ensureConsistentType(field.resource) ===
                                    currentResourceVal,
                                );
                              return (
                                permsForThisResourceInFields.length ===
                                rolePermissionRes.data.length
                              );
                            })()}
                            onChange={() => {
                              addAllPermissions(roleResource);
                            }}
                          />
                        </div>
                      </td>
                      {rolePermissionRes?.data.map((permDef, colIndex) => (
                        <td
                          key={`perm-${ensureConsistentType(roleResource.value)}-${ensureConsistentType(permDef.value)}-${colIndex}`}
                        >
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            title={`${permDef.text}-${roleResource.text}`}
                          >
                            <Checkbox
                              isChecked={
                                permissionsFields.findIndex(
                                  (field) =>
                                    ensureConsistentType(field.resource) ===
                                      ensureConsistentType(
                                        roleResource.value,
                                      ) &&
                                    ensureConsistentType(field.permission) ===
                                      ensureConsistentType(permDef.value),
                                ) !== -1
                              }
                              onChange={() => {
                                updatePermission(roleResource, permDef);
                              }}
                            />
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Flex w="100%" justify="flex-end" flexDirection="row" mt={4}>
                <Button
                  type="submit"
                  isLoading={creatingRequest || requestingRoleEditing}
                >
                  Submit
                </Button>
              </Flex>
            </form>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
